import { ApiError } from '@anm/api';
import {
  FormatNames,
  GetLandingRequest,
  Landing,
  SaveLandingData,
  UpdateLandingData
} from '@anm/api/modules/hosting';
import {
  createAction,
  createAsyncAction
} from '@anm/helpers/saga/typesafe-actions';

export const getLanding = createAction('wave.video/landings/GET_LANDING')<
  GetLandingRequest
>();

export const getLandingAsync = createAsyncAction(
  'wave.video/landings/GET_LANDING_REQUEST',
  'wave.video/landings/GET_LANDING_SUCCESS',
  'wave.video/landings/GET_LANDING_FAILURE'
)<GetLandingRequest, Landing, ApiError>();

export const updateLanding = createAction('wave.video/landings/UPDATE_LANDING')<
  UpdateLandingData
>();

export const discardLandingChanges = createAction(
  'wave.video/landings/DISCARD_LANDING_CHANGES'
)();

export const saveLanding = createAction('wave.video/landings/SAVE_LANDING')<
  SaveLandingData
>();

export const saveLandingAsync = createAsyncAction(
  'wave.video/landings/SAVE_LANDING_REQUEST',
  'wave.video/landings/SAVE_LANDING_SUCCESS',
  'wave.video/landings/SAVE_LANDING_FAILURE'
)<UpdateLandingData, { id: string }, ApiError>();

export const cleanLandingsStore = createAction(
  'wave.video/landings/CLEAN_LANDINGS_STORE'
)();

export const updateLandingViewType = createAction(
  'wave.video/landings/UPDATE_LANDING_VIEW_TYPE'
)<FormatNames>();
